module.exports = __webpack_public_path__ + "img/c2-pop.ef350d46.png";